import { PaletteFragmentFragment } from "src/api/graphql/__generated__/graphql";

export const DefaultPalette = {
	primary: "#717784",
	secondary: "#101218",
	tertiary: "#090909",
} satisfies PaletteFragmentFragment;
